var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSocialProfileClick = function SvgSocialProfileClick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.704 34.875L34.854 33.192C34.953 32.1025 34.6517 31.0143 34.0065 30.1309C33.3613 29.2474 32.4164 28.6293 31.3485 28.392L25.872 27.174V18.5625C25.872 17.8166 25.5757 17.1012 25.0483 16.5738C24.5208 16.0463 23.8054 15.75 23.0595 15.75C22.3136 15.75 21.5982 16.0463 21.0708 16.5738C20.5433 17.1012 20.247 17.8166 20.247 18.5625V32.3625L18.0315 30.7005C17.5887 30.3688 17.0411 30.2079 16.4893 30.2473C15.9374 30.2867 15.4182 30.5238 15.027 30.915C14.6358 31.3062 14.3988 31.8254 14.3594 32.3772C14.32 32.9291 14.4808 33.4767 14.8125 33.9195L15.5235 34.8675",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.625 23.625V3.375C32.625 2.77826 32.3879 2.20597 31.966 1.78401C31.544 1.36205 30.9717 1.125 30.375 1.125H3.375C2.77826 1.125 2.20597 1.36205 1.78401 1.78401C1.36205 2.20597 1.125 2.77826 1.125 3.375V28.125C1.125 28.7217 1.36205 29.294 1.78401 29.716C2.20597 30.1379 2.77826 30.375 3.375 30.375H10.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 7.875H32.625",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.375H6.75C6.12868 12.375 5.625 12.8787 5.625 13.5V20.25C5.625 20.8713 6.12868 21.375 6.75 21.375H13.5C14.1213 21.375 14.625 20.8713 14.625 20.25V13.5C14.625 12.8787 14.1213 12.375 13.5 12.375Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 25.875H14.6265",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 12.375H28.1265",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialProfileClick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social-profile-click.eb255961.svg";
export { ForwardRef as ReactComponent };